



































































































import { getFlagEmoji } from "@/lib/CountryCodeHelper";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { IInvoice, InvoiceTypeEnum } from "@/models/invoice.entity";
import { AccountingTypeEnum } from "@/models/product.entity";
import { mixins } from "vue-class-component";
import { Component, Prop, Ref, Watch } from "vue-property-decorator";
import { formatCurrency } from "@/lib/utility/currency-helper";
import InvoiceFormLinesTableRow from "./InvoiceFormLinesTableRow.vue";
import { InvoiceLine } from "@/models/invoice-line.entity";
import InvoiceFormInput from "./InvoiceFormInput.vue";
import RulesMixin from "@/mixins/RulesMixin.vue";
import InvoicePartyForm from "./InvoicePartyForm.vue";
import RefsSelectionByType from "../utility/RefsSelectionByType.vue";
import RefsCompany from "../utility/RefsCompany.vue";
import { InvoiceParty } from "@/models/invoice-party.entity";
import { ICompany } from "@/models/company.entity";
import { getAutocompleteFilter } from "@/lib/utility/filter";
import { CurrencyEnum } from "@/lib/enum/currency.enum";
import Tooltip from "../utility/tooltip.vue";
import LineItemsForm from "@/components/repair-estimate/LineItemsForm.vue";
import CompanySelection from "../partner/report/v2/contact/CompanySelection.vue";
import { CoverageTypeEnum } from "@/store/enum/coverage-type.enum";

@Component({
  components: {
    InvoiceFormLinesTableRow,
    InvoiceFormInput,
    InvoicePartyForm,
    RefsSelectionByType,
    RefsCompany,
    Tooltip,
    LineItemsForm,
    CompanySelection
  },
  filters: {
    getFlagEmoji
  }
})
export default class InvoiceInboundForm extends mixins(PermissionMixin, RulesMixin) {
  readonly formatCurrency = formatCurrency;
  readonly InvoiceLine = InvoiceLine;
  readonly getAutocompleteFilter = getAutocompleteFilter;
  readonly CurrencyEnum = CurrencyEnum;
  readonly AccountingTypeEnum = AccountingTypeEnum;

  @Ref("sellerForm") sellerForm!: InvoicePartyForm;

  @Ref("buyerForm") buyerForm!: InvoicePartyForm;

  buyerCompany: ICompany | null = null;
  sellerCompany: ICompany | null = null;

  @Prop()
  value!: IInvoice;

  @Prop({ default: false })
  readonly!: boolean;

  @Prop()
  coverageType?: CoverageTypeEnum;

  @Prop({ default: true })
  hideBuyer!: boolean;

  isValid = false;

  get invoiceTypes() {
    return [InvoiceTypeEnum.COMMERCIAL, InvoiceTypeEnum.CREDIT_NOTE];
  }

  @Watch("sellerCompany")
  onSellerCompanyChange() {
    this.$log.debug(this.sellerCompany);

    if (this.sellerCompany) {
      this.value.seller = this.sellerCompany.invoiceParty;
      this.value.sellerCompany = this.sellerCompany;
    }
  }

  @Watch("buyerCompany")
  onBuyerCompanyChange() {
    this.$log.debug(this.buyerCompany);

    if (this.buyerCompany) {
      this.value.buyer = this.buyerCompany.invoiceParty;
      this.value.buyerCompany = this.buyerCompany;
    }
  }

  @Watch("isValid")
  onWatchIsValid() {
    this.$emit("isValid", this.isValid && this.value.seller && this.value.lineItems.length > 0);
  }

  resetSeller() {
    this.value.sellerCompany = undefined;
    this.value.seller = new InvoiceParty();

    this.$forceUpdate();

    this.$nextTick(() => {
      document.getElementById("filterCard")?.focus();
    });
  }

  setSeller(company: ICompany) {
    this.value.sellerFromCompany = company;

    this.$forceUpdate();

    this.$nextTick(() => {
      document.getElementById("invoiceType")?.focus();
    });
  }
}
